
import React from "react";
import { useHeroCarousel } from "@/hooks/useHeroCarousel";

interface CarouselSectionProps {
  memorialId: string | undefined;
}

export const CarouselSection: React.FC<CarouselSectionProps> = ({ memorialId }) => {
  const { currentSlide, featuredPhotos, isLoading } = useHeroCarousel(memorialId);

  return (
    <div className="relative w-full md:w-[85%] lg:w-[75%] xl:w-[70%] h-full mx-auto">
      {!isLoading && featuredPhotos.length > 0 ? (
        featuredPhotos.map((image, index) => (
          <div
            key={image}
            className={`absolute inset-0 w-full h-full transition-opacity duration-1000 ease-in-out ${
              index === currentSlide ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={image}
              alt={`Featured photo ${index + 1}`}
              className="w-full h-full object-cover object-top"
              onError={(e) => {
                console.error(`[HeroSection] Error loading image: ${image}`);
                e.currentTarget.src = '/placeholder.svg'; // Fallback to placeholder image
              }}
            />
          </div>
        ))
      ) : (
        <div className="absolute inset-0 bg-gray-200 flex items-center justify-center">
          <p className="text-gray-500">
            {isLoading ? "Loading photos..." : "No featured photos"}
          </p>
        </div>
      )}
      
      <div 
        className="absolute inset-0 w-full h-full pointer-events-none"
        style={{
          background: `
            linear-gradient(0deg, rgba(255,255,255,1) 15%, rgba(0,0,0,0.2) 100%),
            linear-gradient(90deg, rgba(0,0,0,0.12) 0%, transparent 15%, transparent 85%, rgba(0,0,0,0.12) 100%)
          `
        }}
      />
    </div>
  );
};
